var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDisparityIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8.7c.4-.4 1-.4 1.4 0l9.1 9.1c.4.4.4 1 0 1.4l-9.1 9.1c-.4.4-1 .4-1.4 0L.7 11.2c-.4-.4-.4-1 0-1.4L9.8.7z",
    fill: "#E35942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6H7v9.5h1V11h6.5L13 9l1.5-2H8V6z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIiBmaWxsPSJub25lIj48cGF0aCBkPSJNOS44IDAuN0MxMC4yIDAuMyAxMC44IDAuMyAxMS4yIDAuN0wyMC4zIDkuOEMyMC43IDEwLjIgMjAuNyAxMC44IDIwLjMgMTEuMkwxMS4yIDIwLjNDMTAuOCAyMC43IDEwLjIgMjAuNyA5LjggMjAuM0wwLjcgMTEuMkMwLjMgMTAuOCAwLjMgMTAuMiAwLjcgOS44TDkuOCAwLjdaIiBmaWxsPSIjRTM1OTQyIi8+PHBhdGggZD0iTTggNkg3VjE1LjVIOFYxMUgxNC41TDEzIDkgMTQuNSA3SDhWNloiIGZpbGw9IndoaXRlIi8+PC9zdmc+";
export { SvgDisparityIcon as ReactComponent };